import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { SendContactRequest } from "../../apis/notification/send_contact_request";
import { CheckContactRequest } from "../../apis/notification/check_contact_request";

export default function CompanyProfile({ userData, links, setViewProfile }) {
    const navigate = useNavigate();
    const [gstData, setGstData] = useState("");
    const [viewGst, setViewGst] = useState(false);
    const [loginData, setLogindata] = useState('');
    const [viewMobile, setViewMobile] = useState(false);
    const [viewEmail, setViewEmail] = useState(false);

    const [checkViewStatus, setCheckViewStatus] = useState(API_STATUS);
    const [reqViewStatus, setReqViewStatus] = useState(API_STATUS);

    // Track active loading button type ('email' | 'mobile' | null)
    const [loadingType, setLoadingType] = useState(null);

    // Helper functions for masking
    const maskEmail = (email) => {
        if (!email) return "";
        const [name, domain] = email.split("@");
        if (!domain) return email;
        const maskedName = name.length > 2 
            ? name.substring(0, 2) + "*".repeat(name.length - 2) 
            : name + "*";
        return `${maskedName}@${domain}`;
    };

    const maskMobile = (mobile) => {
        if (!mobile) return "";
        const str = String(mobile);
        if (str.length <= 4) return "*".repeat(str.length);
        return str.substring(0, 2) + "*".repeat(str.length - 4) + str.slice(-2);
    };

    useEffect(() => {
        if (userData.gstData !== null) {
            setGstData(JSON.parse(userData.gstData));
        }
        setLogindata(JSON.parse(sessionStorage.getItem('LOGIN_DATA')));
        CheckContactRequest({ userId: userData['userId'] }, setCheckViewStatus);
    }, []);

    const sendRequest = (type) => {
        setLoadingType(type); // Set loading state for specific button
        const body = {
            token: userData['userId'],
            type: type,
            user_name: loginData['firstName'] + ' ' + loginData['u_lastName']
        };
        SendContactRequest(body, setReqViewStatus);
    };

    // Reset loading state once API request finishes
    useEffect(() => {
        if (!reqViewStatus.isLoader) {
            setLoadingType(null);
        }
    }, [reqViewStatus]);

    useEffect(() => {
        if (!checkViewStatus.isError && !checkViewStatus.isLoader && checkViewStatus.data) {
            const res = checkViewStatus.data;
            if (res['status'] === 1) {
                setViewEmail(res['data']['email'] === 1);
                setViewMobile(res['data']['mobile'] === 1);
            }
        }
    }, [checkViewStatus]);

    return (
        <div className="max-w-2xl mx-auto px-1 py-1">
            <div className="page__heading py-2 md:py-6 mt-2 md:mt-6">
                <Link onClick={() => setViewProfile(false)}>
                    <ion-icon name="chevron-back-outline"></ion-icon> Back
                </Link>
            </div>

            <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">
                <div className="flex md:gap-8 gap-4 items-center md:p-10 p-6">
                    <div className="relative md:w-20 md:h-20 w-12 h-12 shrink-0">
                        <img src={userData['userPic']} alt="" className="w-full h-full absolute object-cover" />
                    </div>
                    <div className="flex-1">
                        <h3 className="md:text-xl text-base font-semibold text-black dark:text-white">
                            {userData['firstName']} {userData['lastName']}
                        </h3>
                        <p className="text-sm text-blue-600 mt-1 font-normal">{userData['subCat']}</p>
                    </div>
                </div>
            </div>

            <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80" style={{ position: 'relative' }}>
                <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                    <div className="uk-active" style={{ position: 'relative' }}>
                        <div className="space-y-4">
                            
                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> Company </label> :
                                <div className="flex-1 md:mt-4">
                                    {userData['company']}
                                </div>
                            </div>

                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> Registered as </label> :
                                <div className="flex-1 md:mt-4">
                                    {userData['category'] + '-' + userData['subCat']}
                                </div>
                            </div>

                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> Location </label> :
                                <div className="flex-1 md:mt-4">
                                    {userData['state'] + '-' + userData['city']}
                                </div>
                            </div>

                            {/* EMAIL FIELD WITH LOADING STATE */}
                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> Email </label> :
                                <div className="flex-1 md:mt-4 flex items-center gap-3">
                                    <span>
                                        {viewEmail ? userData['email'] : '**********'}
                                    </span>
                                    {!viewEmail && (
                                        <button
                                            type="button"
                                            disabled={loadingType === 'email'}
                                            onClick={() => sendRequest('email')}
                                            className="inline-flex items-center gap-1.5 text-xs bg-blue-600 text-white px-2.5 py-1 rounded hover:bg-blue-700 disabled:opacity-50 transition"
                                        >
                                            {loadingType === 'email' ? (
                                                <>
                                                    <svg className="animate-spin h-3.5 w-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                    </svg>
                                                    <span>...</span>
                                                </>
                                            ) : (
                                                "View"
                                            )}
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* MOBILE FIELD WITH LOADING STATE */}
                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> Mobile </label> :
                                <div className="flex-1 md:mt-4 flex items-center gap-3">
                                    <span>
                                        {viewMobile ? userData['mobile'] : '**********'}
                                    </span>
                                    {!viewMobile && (
                                        <button
                                            type="button"
                                            disabled={loadingType === 'mobile'}
                                            onClick={() => sendRequest('mobile')}
                                            className="inline-flex items-center gap-1.5 text-xs bg-blue-600 text-white px-2.5 py-1 rounded hover:bg-blue-700 disabled:opacity-50 transition"
                                        >
                                            {loadingType === 'mobile' ? (
                                                <>
                                                    <svg className="animate-spin h-3.5 w-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                    </svg>
                                                    <span>...</span>
                                                </>
                                            ) : (
                                                "View"
                                            )}
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> GSTIN </label> :
                                <div className="flex-1 md:mt-4">
                                    <div>
                                        <Link onClick={() => setViewGst(!viewGst)} className="text-blue-600">
                                            {userData['gstin']}
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {gstData !== "" && viewGst && (
                                <div style={{ borderWidth: 1, borderColor: '#ddd', padding: 10, backgroundColor: '#e8f4ff' }}>
                                    <div className="flex items-center gap-5">
                                        <label className="w-20 md:w-32 text-right"> Trade Name </label> :
                                        <div className="flex-1 md:mt-4">{gstData.tradeNam}</div>
                                    </div>
                                    <div className="flex items-center gap-5 mt-3">
                                        <label className="w-20 md:w-32 text-right"> GST Address </label> :
                                        <div className="flex-1 md:mt-4">{gstData.pradr?.adr}</div>
                                    </div>
                                    <div className="flex items-center gap-5 mt-3">
                                        <label className="w-20 md:w-32 text-right"> GST Status </label> :
                                        <div className="flex-1 md:mt-4">{gstData.sts}</div>
                                    </div>
                                    <div className="flex items-center gap-5 mt-3">
                                        <label className="w-20 md:w-32 text-right"> Company Type </label> :
                                        <div className="flex-1 md:mt-4">{gstData.ctb}</div>
                                    </div>
                                </div>
                            )}

                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> PAN </label> :
                                <div className="flex-1 md:mt-4">{userData['pan']}</div>
                            </div>

                            <div className="flex items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> External Links </label> :
                                <div className="flex-1 md:mt-4">
                                    {links.map((item, i) => (
                                        <p key={i}>
                                            <i className="fa fa-link" aria-hidden="true"></i>{" "}
                                            <a href={item.ul_link}>{item.ul_title}</a>
                                        </p>
                                    ))}
                                </div>
                            </div>

                            <div className="items-center gap-5">
                                <label className="w-20 md:w-32 text-right"> More about </label> :
                                <div className="flex-1 md:mt-4">{userData['about']}</div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}